import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'

export const HeroSection = styled.section`
	height: 700px;
	min-height: 700px;
	${tw`w-full bg-cover mb-4 md:mb-0 bg-no-repeat bg-center`}
	background-color: #c5cbc0;
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 768px) and (max-width: 1023px) {
		height: 600px;
		min-height: 600px;
	}
	@media (min-width: 525px) and (max-width: 767px) {
		height: 500px;
		min-height: 500px;
	}

	@media (max-width: 524px) {
		height: 400px;
		min-height: 400px;
	}
`
export const HeroItemsContainer = styled.div`
${tw`flex flex-col w-full h-full pt-4 px-2 md:px-0 md:pt-12 items-center justify-center relative`}
	${tw`bg-cover bg-no-repeat bg-center`}
	min-height: 700px;
	@media (min-width: 1350px) {
		${tw`bg-top`}
		background-image: url(${({ sources }) => sources[0].srcWebp});
		background-image: url(${({ sources }) => sources[0].src});
	}
	@media (min-width: 1024px) and (max-width: 1349px) {
		background-image: url(${({ sources }) => sources[1].srcWebp});
		background-image: url(${({ sources }) => sources[1].src});
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		background-image: url(${({ sources }) => sources[2].srcWebp});
		background-image: url(${({ sources }) => sources[2].src});
		height: 600px;
		min-height: 600px;
	}
	@media (min-width: 525px) and (max-width: 767px) {
		background-image: url(${({ sources }) => sources[3].srcWebp});
		background-image: url(${({ sources }) => sources[3].src});
		height: 500px;
		min-height: 500px;
	}
	@media (max-width: 524px) {
		background-image: url(${({ sources }) => sources[4].srcWebp});
		background-image: url(${({ sources }) => sources[4].src});
		height: 400px;
		min-height: 400px;
		background-position: 100%;
	}
`
export const HeroButtons = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row mt-4`}
	}
	${tw`flex flex-col mt-2 lg:mt-8`}
`
export const HeroSeeAllLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`mb-0 mr-2`}
	}
	${tw`border bg-yellow-500 border-yellow-500 hover:border-yellow-400 hover:bg-yellow-400 rounded-lg mb-2 mr-0`}
`
export const HeroSeeAll = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans text-dolphin-gray uppercase text-xs md:text-base py-3 lg:py-4 px-8 leading-none w-full`}
`
export const HeroBookLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`ml-2 mr-2 mb-0`}
	}
	${tw`border-2 border-white bg-white hover:bg-dolphin-gray rounded-lg ml-0 mb-2`}
`
export const HeroBook = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans text-dolphin-gray hover:text-white leading-none text-xs md:text-base uppercase py-3 lg:py-4 px-8`}
`
export const BookDemoLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`ml-2`}
	}
	${tw`border-2 border-mineral-teal bg-mineral-teal hover:bg-blue-600 hover:border-blue-600 rounded-lg ml-0`}
`
export const BookDemo = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans text-dolphin-gray hover:text-white leading-none text-xs md:text-base uppercase py-3 lg:py-4 px-8`}
`
export const Bold = tw.b`font-bold`
export const Heading1 = styled.h1`
	@media (min-width: 525px) {
		${tw`text-3xl`}
	}
	${tw`font-display text-white font-bold text-2xl md:text-4xl lg:text-5xl xl:text-6xl text-center mt-10 mb-6 md:w-8/12 xl:w-8/12 xxl:w-7/12`}
`
export const BannerText = styled.p`
	@media (min-width: 525px) {
		${tw`block text-lg`}
	}
	${tw`font-display text-white hidden md:text-2xl xl:text-3xl mb-6`}
`

export const DolphinLogo = styled.img`
	@media (min-width: 525px) {
		${tw`w-48 mt-0 mb-4`}
	}
	${tw`w-40 md:w-56 xl:w-1/6 my-2`}
`
export const ClientCareLogo = styled.img`
	@media (min-width: 525px) {
		${tw`w-32`}
	}
	${tw`absolute w-24 md:w-40 lg:w-48 xxxl:w-56`}

	@media(min-width: 320px) {
		right: 2%;
		bottom: 3%;
	}
	@media (min-width: 525px) {
		right: 3%;
		bottom: 2%;
	}
	@media (min-width: 768px) {
		right: 5%;
		bottom: 3%;
	}
`

export const Section = tw.section`flex flex-col w-full justify-center items-center py-16 bg-light-gray`
export const Title = tw.h2`font-display font-bold text-4xl text-center mb-2 text-blue-500`
export const Subtitle = tw.h3`font-sans text-2xl text-center mb-5 px-4 md:px-8`
export const Innertext = tw.h4`font-sans text-xl text-center mb-15 px-4 md:px-8 max-w-3xl`
export const Item = styled.div`
	${tw`flex flex-col px-4 items-center mb-2 mb-8 max-w-xl flex-none`}
	${({ arrLen }) =>
		arrLen < 3
			? tw`w-full md:w-6/12 xl:w-6/12`
			: tw`w-full md:w-6/12 xl:w-4/12`}
	transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
	overflow: hidden;
	.item-image {
		transition: opacity 0.3s ease-in-out;
		width: 100%;
		height: auto;
		z-index: 0;
	}
	> a {
		${tw`w-full`}
	}
	> div > a {
		transition: 0.3s ease-in-out;
		background-color: rgba(34, 41, 47, 0.3);
		${tw`text-white flex bottom-0 w-full py-1 mt-4 text-center justify-center items-center tracking-widest capitalize hover:bg-black`}
	}
	&:hover {
		.item-image {
			opacity: 0.875;
		}
	}
`
export const Content = tw.div`flex flex-col flex-1 w-full pt-8 rounded-b items-center justify-center bg-white`
export const ItemSubTitle = tw.h4`font-display text-base leading-tight mb-2 md:w-full xl:w-9/12 mb-4`
export const Paragraph = tw.p`font-display relative mb-2`
export const Italic = styled.i`
	:before {
		position: absolute;
		content: '';
		height: 6px;
		width: 6px;
		left: 0;
		top: 5px;
		background: #58c8df;
		border-radius: 100%;
	}
`
export const UnorderedList = tw.ul`mb-6`
export const ItemButton = tw.button`py-2`
export const ItemImage = styled.img`
	max-width: 100px;
	${tw`mb-4`}
`
export const FeaturedButtonHolder = styled.div`
	${({ arrLen }) => (arrLen < 3 ? tw`w-9/12 xl:w-6/12` : tw`w-9/12`)}
	${tw`m-auto relative`}
	/* ${tw`w-9/12 m-auto relative`} */
`
export const FeaturedContainer = tw.div`overflow-hidden mb-4`
export const FeaturedHolder = tw.div`w-full flex flex-row`

export const Previous = styled.button`
	${tw`absolute`}
	left: -6%;
	top: 45%;

	@media (max-width: 1023px) {
		left: -8%;
	}

	@media (max-width: 767px) {
		left: -11%;
	}

	@media (max-width: 524px) {
		left: -16%;
	}

	&:focus:focus {
		${tw`outline-none shadow-none`}
	}
`
export const Next = styled.button`
	${tw`absolute`}
	right: -6%;
	top: 45%;

	@media (max-width: 1023px) {
		right: -8%;
	}

	@media (max-width: 767px) {
		right: -11%;
	}

	@media (max-width: 524px) {
		right: -16%;
	}

	&:focus:focus {
		${tw`outline-none shadow-none`}
	}
`
export const ViewMore = styled.div`
	${tw`text-center py-2`}
`
export const ViewMoreBtn = styled(Link)`
	${tw`py-2 px-4 border-2 border-dolphin-gray hover:bg-transparent bg-dolphin-gray text-white hover:text-current rounded-lg`}
`

export const ReviewsSection = styled.section`
	background: #66b4cb; /* Old browsers */
	background: -moz-linear-gradient(
		left,
		#66b4cb 0%,
		#64b1cb 1%,
		#65b3ca 2%,
		#62afc9 6%,
		#5fafc8 6%,
		#5fafc8 7%,
		#62afcb 7%,
		#62afcb 7%,
		#5fafc8 7%,
		#60adc7 9%,
		#61aeca 9%,
		#61aeca 9%,
		#5eaec9 9%,
		#5eaec7 10%,
		#58a9c6 19%,
		#56a7c4 19%,
		#56a7c4 23%,
		#53a7c3 24%,
		#52a5c3 27%,
		#50a3c1 27%,
		#479ebc 42%,
		#469bba 42%,
		#469dbb 43%,
		#469abc 43%,
		#459bbc 45%,
		#4399ba 45%,
		#449abb 47%,
		#4298b9 47%,
		#3f98ba 53%,
		#3d96b8 53%,
		#4096b9 53%,
		#4096b9 53%,
		#3d96b8 54%,
		#3c95b7 55%,
		#3892b5 62%,
		#3690b3 62%,
		#3690b3 66%,
		#348eb1 66%,
		#358fb4 66%,
		#358fb4 66%,
		#3390b2 68%,
		#338db0 68%,
		#348eb3 68%,
		#348eb3 68%,
		#328fb1 69%,
		#308cb1 73%,
		#2e8aaf 73%,
		#2f8bb0 75%,
		#2d89ae 75%,
		#2c8ab0 79%,
		#2a88ae 79%,
		#2c88af 79%,
		#2785ab 86%,
		#2484ac 86%,
		#2683ac 87%,
		#2484aa 88%,
		#2081ab 93%,
		#2181a9 93%,
		#1f7fa7 94%,
		#2080aa 94%,
		#1f80aa 95%,
		#1d7ea8 96%,
		#1c7da7 100%
	);
	background: -webkit-linear-gradient(
		left,
		#66b4cb 0%,
		#64b1cb 1%,
		#65b3ca 2%,
		#62afc9 6%,
		#5fafc8 6%,
		#5fafc8 7%,
		#62afcb 7%,
		#62afcb 7%,
		#5fafc8 7%,
		#60adc7 9%,
		#61aeca 9%,
		#61aeca 9%,
		#5eaec9 9%,
		#5eaec7 10%,
		#58a9c6 19%,
		#56a7c4 19%,
		#56a7c4 23%,
		#53a7c3 24%,
		#52a5c3 27%,
		#50a3c1 27%,
		#479ebc 42%,
		#469bba 42%,
		#469dbb 43%,
		#469abc 43%,
		#459bbc 45%,
		#4399ba 45%,
		#449abb 47%,
		#4298b9 47%,
		#3f98ba 53%,
		#3d96b8 53%,
		#4096b9 53%,
		#4096b9 53%,
		#3d96b8 54%,
		#3c95b7 55%,
		#3892b5 62%,
		#3690b3 62%,
		#3690b3 66%,
		#348eb1 66%,
		#358fb4 66%,
		#358fb4 66%,
		#3390b2 68%,
		#338db0 68%,
		#348eb3 68%,
		#348eb3 68%,
		#328fb1 69%,
		#308cb1 73%,
		#2e8aaf 73%,
		#2f8bb0 75%,
		#2d89ae 75%,
		#2c8ab0 79%,
		#2a88ae 79%,
		#2c88af 79%,
		#2785ab 86%,
		#2484ac 86%,
		#2683ac 87%,
		#2484aa 88%,
		#2081ab 93%,
		#2181a9 93%,
		#1f7fa7 94%,
		#2080aa 94%,
		#1f80aa 95%,
		#1d7ea8 96%,
		#1c7da7 100%
	);
	background: linear-gradient(
		to right,
		#66b4cb 0%,
		#64b1cb 1%,
		#65b3ca 2%,
		#62afc9 6%,
		#5fafc8 6%,
		#5fafc8 7%,
		#62afcb 7%,
		#62afcb 7%,
		#5fafc8 7%,
		#60adc7 9%,
		#61aeca 9%,
		#61aeca 9%,
		#5eaec9 9%,
		#5eaec7 10%,
		#58a9c6 19%,
		#56a7c4 19%,
		#56a7c4 23%,
		#53a7c3 24%,
		#52a5c3 27%,
		#50a3c1 27%,
		#479ebc 42%,
		#469bba 42%,
		#469dbb 43%,
		#469abc 43%,
		#459bbc 45%,
		#4399ba 45%,
		#449abb 47%,
		#4298b9 47%,
		#3f98ba 53%,
		#3d96b8 53%,
		#4096b9 53%,
		#4096b9 53%,
		#3d96b8 54%,
		#3c95b7 55%,
		#3892b5 62%,
		#3690b3 62%,
		#3690b3 66%,
		#348eb1 66%,
		#358fb4 66%,
		#358fb4 66%,
		#3390b2 68%,
		#338db0 68%,
		#348eb3 68%,
		#348eb3 68%,
		#328fb1 69%,
		#308cb1 73%,
		#2e8aaf 73%,
		#2f8bb0 75%,
		#2d89ae 75%,
		#2c8ab0 79%,
		#2a88ae 79%,
		#2c88af 79%,
		#2785ab 86%,
		#2484ac 86%,
		#2683ac 87%,
		#2484aa 88%,
		#2081ab 93%,
		#2181a9 93%,
		#1f7fa7 94%,
		#2080aa 94%,
		#1f80aa 95%,
		#1d7ea8 96%,
		#1c7da7 100%
	);
	${tw`w-full py-16 px-8 lg:px-12`}
`
export const ReviewContainer = tw.div`w-full flex flex-col md:flex-row`
export const Review = styled.div`
	${tw`w-full md:w-4/12 flex flex-col items-center justify-center`}
	&:not(:nth-of-type(3n)) {
		${tw`border-b md:border-r md:border-b-0 border-white pb-4 md:pb-0 mb-4 md:mb-0`}
	}
`
export const ReviewTitle = tw.p`font-display text-base lg:text-lg text-white w-9/12 text-center`
export const ReviewParagraph = tw.p`font-display text-5xl lg:text-6xl text-white font-bold mb-2`

export const DolphinVideoFeature = tw.section`w-full flex flex-col`
export const DolphinVideoHolder = styled.div`
	${tw`flex flex-col w-full relative overflow-hidden`}

	video {
		object-fit: fill;
		width: 100%;
	}

	@media (min-width: 375px) {
		video {
			height: 230px;
			max-height: 230px;
		}
	}

	@media (min-width: 525px) {
		video {
			height: 320px;
			max-height: 320px;
		}
	}

	@media (min-width: 768px) {
		video {
			height: 420px;
			max-height: 420px;
		}
	}

	@media (min-width: 1024px) {
		video {
			height: 500px;
			max-height: 500px;
		}
	}
	@media (min-width: 1280px) {
		video {
			height: 600px;
			max-height: 600px;
		}
	}
	@media (min-width: 1400px) {
		video {
			height: 750px;
			max-height: 750px;
		}
	}
`
export const DolphinVideoContainer = styled.div`
	background: url(${({ bgImage }) => (bgImage ? bgImage : '')});
	background-color: ${({ bg }) => bg};
	${tw`absolute flex flex-col w-full m-auto items-center justify-center h-full p-4 md:p-0 bg-cover bg-no-repeat`}
	top:0;
	left: 0;
	right: 0;
`
export const PlayPauseBtn = styled.button`
	${tw`absolute cursor-pointer`}
	top: 30%;
	transition: 0.5s ease;
	opacity: ${({ fade }) => fade};

	@media (min-width: 320px) and (max-width: 524px) {
		> div {
			height: 30px !important;
			width: 30px !important;
		}
	}

	@media (min-width: 525px) {
		> div {
			height: 35px;
			width: 35px;
		}
	}

	@media (min-width: 768px) {
		> div {
			height: 60px;
			width: 60px;
		}
	}

	@media (min-width: 1024px) {
		> div {
			height: 70px;
			width: 70px;
		}
	}

	@media (max-width: 1399px) {
		top: 25%;
	}
	@media (max-width: 1279px) {
		top: 20%;
	}
	@media (max-width: 767px) {
		top: 15%;
	}
	@media (max-width: 524px) {
		top: 8%;
	}
`
export const VideoHook = styled.h2`
	@media (min-width: 525px) {
		${tw`text-xl mt-4 text-white`}
	}
	@media (max-width: 524px) {
		${tw`text-base mt-8`}
	}
	${tw`font-display text-gray-900 text-base md:text-2xl lg:text-4xl font-bold mt-10 md:mt-0 mb-2 text-center`}
`
export const Heading3 = styled.h3`
	@media (min-width: 525px) {
		${tw`text-white`}
	}
	${tw`font-display text-gray-900 text-sm lg:text-2xl font-bold mb-4 text-center`}
`
export const DolphinDiffParagraph = tw.p`text-center hidden md:block text-base lg:text-xl w-10/12 xl:w-7/12 mx-auto`
export const DolphinFeatureHolder = tw.div`bg-white flex flex-col items-center`
export const DolphinFeatureContainer = styled.div`
	${tw`w-full xl:w-11/12 px-4 xl:px-0 m-auto flex flex-row flex-wrap`}
	min-height: 350px;
`
export const Feature = styled.div`
	@media (min-width: 525px) {
		${tw`my-8`}
	}
	${tw`w-full md:w-6/12 lg:w-4/12 flex flex-col items-center my-4 relative`}
	@media(min-width:1024px) {
		margin: -4rem 0 0;
	}
	z-index: 1;
`
export const FeatureImg = tw.img`w-32 mb-12`
export const FeatureName = tw.h4`font-display text-3xl text-blue-500 font-bold mb-3 text-center`
export const FeatureText = tw.p`md:w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12 mx-auto text-center text-lg xl:text-xl font-display leading-snug`

export const VideoOverlay = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row`}
	}
	${tw`flex flex-col w-full`}
`
export const ClimateCareContainer = styled.div`
	@media (min-width: 525px) {
		${tw`order-1 w-4/12 justify-end`}
	}
	${tw`order-2 w-full xl:w-5/12 items-center justify-center xl:justify-center flex`}
`
export const TextsContainer = styled.div`
	@media (min-width: 525px) {
		${tw`order-2 px-8 w-8/12`}
	}
	${tw`order-1 w-full xl:w-7/12 items-center justify-end flex flex-col relative`}
`
export const ClimateCareImage = styled.img`
	@media (min-width: 525px) {
		${tw`w-9/12`}
	}
	${tw`w-14 xl:w-6/12`}
`

export const LearnMore = styled(Link)`
	${tw`font-display uppercase py-3 bg-yellow-500 text-white font-bold w-5/12 md:w-3/12 text-center rounded mb-8 hover:bg-yellow-400`}
`

export const TopModelsSection = tw.section`w-full py-12 bg-light-gray`
export const TopModelsContainer = tw.div`flex flex-col w-11/12 lg:w-10/12 mx-auto`
export const ItemsContainer = tw.div`flex flex-col md:flex-row mb-8`
export const ItemContainer = styled.div`
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	${tw`w-11/12 mx-auto mb-4 md:mb-0 md:w-6/12 md:mx-2`}
`
export const ItemInnerContainer = tw.div`bg-white flex flex-col py-12 h-full`
export const ItemImageContainer = styled.div`
	${tw`flex items-center justify-center cursor-pointer`}
	&:hover {
		img {
			opacity: 0.875;
		}
	}
`
export const TopModelItemImage = styled.picture`
	@media (min-width: 325px) {
		height: 180px;
	}

	@media (min-width: 525px) {
		height: 300px;
	}
	@media (min-width: 768px) {
		height: 220px;
	}
	@media (min-width: 1024px) {
		height: 300px;
	}
	@media (min-width: 1280px) {
		height: 350px;
	}
	@media (min-width: 1400px) {
		height: 400px;
	}

	> img {
		@media (min-width: 325px) {
			max-height: 180px;
		}

		@media (min-width: 525px) {
			max-height: 300px;
		}
		@media (min-width: 768px) {
			max-height: 220px;
		}
		@media (min-width: 1024px) {
			max-height: 300px;
		}
		@media (min-width: 1280px) {
			max-height: 350px;
		}
		@media (min-width: 1400px) {
			max-height: 400px;
		}
	}
`
export const DetailsContainer = tw.div`w-10/12 xl:w-8/12 m-auto`
export const ProductName = styled.h3`
	span {
		${tw`font-bold`}
	}
	${tw`font-display text-center text-2xl mt-4`}
`
export const AddToCartContainer = styled.div`
	${tw`flex flex-col justify-center items-center w-10/12 lg:w-8/12 xl:w-6/12 mx-auto mb-2 mt-4`}

	> input {
		${tw`text-center font-display w-3/12 p-2 mr-2`}
		background-color: #eaeaea;

		&[type='number']::-webkit-outer-spin-button,
		&[type='number']::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		&[type='number'] {
			-moz-appearance: textfield;
		}
	}
`
export const Price = tw.p`font-display font-bold text-lg text-center py-3`
export const TopModelFeature = tw.p`font-display text-gray-600 text-center`
export const ItemDetails = styled.div`
	${tw`w-10/12 lg:w-8/12 xl:w-6/12 m-auto`}
`
export const Continue = tw.button`w-full border-2 border-sky hover:border-sky bg-transparent hover:bg-sky hover:text-white text-sky py-2 px-6 rounded uppercase font-display`
export const NullText = tw.p`font-display text-dolphin-gray text-2xl bg-white p-8 w-full text-center`

export const Button = styled.button`
	${tw`font-display w-full uppercase border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 hover:text-dolphin-gray text-white py-2 px-6 rounded cursor-pointer`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const ViewAll = styled(Link)`
	${tw`border-2 border-gray-700 py-2 md:py-3 rounded mt-4 mx-2 font-display text-sm md:text-lg hover:bg-transparent bg-gray-700 hover:text-current text-white text-center px-4`}
`

export const EliteSection = styled.section`
	height: 1250px;
	min-height: 1250px;
	${tw`w-full bg-cover mb-4 md:mb-0 bg-no-repeat bg-center`}
	background-color: #c5cbc0;
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 325px) {
		height: 600px;
		min-height: 600px;
	}
	@media (min-width: 525px) and (max-width: 1023px) {
		height: 700px;
		min-height: 700px;
	}
	@media (min-width: 1024px) and (max-width: 1279px) {
		height: 800px;
		min-height: 800px;
	}
	@media (min-width: 1280px) and (max-width: 1399px) {
		height: 900px;
		min-height: 900px;
	}
	@media (min-width: 1400px) {
		height: 1050px;
		min-height: 1050px;
	}
`
export const EliteContainer = styled.div`
	@media (min-width: 525px) {
		${tw`py-6`}
	}
	${tw`flex flex-col w-full h-full py-4 md:py-10 lg:py-6 xl:py-16 px-2 md:px-8 lg:px-12 xl:px-20 items-center justify-center`}
	${tw`bg-cover bg-no-repeat bg-center`}

	@media (min-width: 1700px) {
		background-image: url(${({ sources }) => sources[0].srcWebp});
		background-image: url(${({ sources }) => sources[0].src});
	}
	@media (min-width: 1400px) and (max-width: 1699px) {
		background-image: url(${({ sources }) => sources[1].srcWebp});
		background-image: url(${({ sources }) => sources[1].src});
	}
	@media (min-width: 1280px) and (max-width: 1399px) {
		background-image: url(${({ sources }) => sources[2].srcWebp});
		background-image: url(${({ sources }) => sources[2].src});
	}
	@media (min-width: 1024px) and (max-width: 1279px) {
		background-image: url(${({ sources }) => sources[3].srcWebp});
		background-image: url(${({ sources }) => sources[3].src});
	}
	@media (min-width: 525px) and (max-width: 1023px) {
		background-image: url(${({ sources }) => sources[4].srcWebp});
		background-image: url(${({ sources }) => sources[4].src});
	}
	@media (min-width: 325px) and (max-width: 524px) {
		background-image: url(${({ sources }) => sources[5].srcWebp});
		background-image: url(${({ sources }) => sources[5].src});
	}
`
export const EliteParagraph = tw.p`font-display text-center mb-6 xxxl:text-xl`
export const EliteItemImage = styled.img`
	@media (min-width: 525px) {
		${tw`w-8/12`}
	}
	${tw`mb-6 w-6/12 lg:w-auto mx-auto`}
	@media (min-width: 1400px) {
		width: 320px;
	}
`
export const EliteDetails = styled.div`
	@media (min-width: 525px) {
		${tw`w-6/12`}
	}
	${tw`md:w-5/12 px-4 lg:px-8 xl:px-16 py-8 mr-auto h-full flex flex-col items-center justify-center`}
	background-color: rgba(255,255,255, .7);
`
export const EliteCta = styled(Link)`
	${tw`bg-yellow-500 hover:bg-yellow-400 py-3 px-7 rounded uppercase mb-4`}
`
export const ThumbnailContainer = styled.div`
	${tw`relative flex items-center justify-center mb-2 h-full`}

	@media(max-width: 767px) {
		> img {
			width: 300px;
		}
	}
	@media (max-width: 524px) {
		> img {
			${tw`hidden`}
		}
	}
`
